import axios from "axios";
const environment = process.env.NODE_ENV
export const api = axios.create({
    baseURL: environment === 'development' ? '/api' : 'https://comback0303.com',
    timeout: 10000,
    // headers: { 'X-Custom-Header': 'foobar' }
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
});

// 请求拦截器
api.interceptors.request.use(
    // 请求发送之前的操作
    (config) => {
        return config;
    },
    // 捕获请求失败的错误
    (error) => {
        return Promise.reject(error);
    }
);

// 响应拦截器
api.interceptors.response.use(
    // 响应成功的操作
    (response) => {
        return response.data;
    },
    // 捕获响应失败的错误
    (error) => {
        return Promise.reject(error);
    }
);